/* import __COLOCATED_TEMPLATE__ from './documents-page.hbs'; */
import { classNames } from '@ember-decorators/component';
import { computed } from '@ember/object';
import { filterBy, reads } from '@ember/object/computed';
import { htmlSafe } from '@ember/template';
import { service } from '@ember/service';
import Component from '@ember/component';
import classic from 'ember-classic-decorator';
import styles from './documents-page.module.scss';

@classic
@classNames(styles.component)
export default class SiteDocumentsPage extends Component {
  @service currentPractice;

  @reads('model.meta.hasDocumentsIntro') hasDocumentsIntro;

  @computed('model.meta.welcomeText')
  get welcomeText() {
    return htmlSafe(this.model.meta.welcomeText);
  }

  @computed('model.[]', 'currentPractice.insuranceInfoDocumentRequestEnabled')
  get visibleRecords() {
    if (this.currentPractice.get('insuranceInfoDocumentRequestEnabled')) {
      return this.model;
    }

    return this.model.filter(
      record => record.constructor.modelName !== 'document-request-insurance-info'
    );
  }

  @filterBy('visibleRecords', 'showAsCompleted', false) incompleteRecords;

  @filterBy('visibleRecords', 'showAsCompleted', true) completedRecords;
}
